(function ($) {
  'use strict';

  if (!$.tangible) {
    $.tangible = new Object();
  };

  $.tangible.faqCopyLink = function (el, options) {
      $(".js-faq__copy").click(function () {
        console.log("click");
        var copyText = $(this).prev(".js-faq__link").attr("href");
        navigator.clipboard.writeText(copyText);
        this.insertAdjacentHTML('afterend', '<div class=c-faq__copied>Link copiato</div>');
        setTimeout(() => { document.querySelectorAll('.c-faq__copied').forEach(el => el.remove()); }, 3000);
      });
  };


})(jQuery);
